module.exports = __webpack_public_path__ + "static/top.140b5784.png";